// Sólo separadores de presentación; letras, guiones y ceros conservan su identidad.
export function normalizarCedulaDocente(valor) {
  return String(valor ?? '').replace(/[.\s]/gu, '');
}
